import { jsxs as p, jsx as s } from "react/jsx-runtime";
import { useState as l } from "react";
import _ from "classnames";
import f from "../../fields/Input/index.js";
import I from "../../hooks/useDebounce.js";
import v from "../../icons/Search.js";
const d = "forma-ui__search-input__search", g = "forma-ui__search-input__active", S = "forma-ui__search-input__searchInput", C = "forma-ui__search-input__searchIcon", e = {
  search: d,
  active: g,
  searchInput: S,
  searchIcon: C
}, b = ({ id: c = "search", onSearch: a, className: o, placeholder: n, onFocus: h, onBlur: u }) => {
  const [r, m] = l(""), i = I((t) => {
    m(t.target.value.trim()), a && a(t.target.value.trim());
  }, 500);
  return /* @__PURE__ */ p("div", { className: _(e.search, r && r.length && e.active, o), children: [
    /* @__PURE__ */ s(v, { className: e.searchIcon }),
    /* @__PURE__ */ s(
      f,
      {
        id: c,
        name: "search",
        viewStyle: "secondary",
        className: e.searchInput,
        placeholder: n,
        onChange: i,
        onFocus: h,
        onBlur: u,
        autoComplete: "off",
        meta: { showClearButton: !0 }
      }
    )
  ] });
};
export {
  b as default
};
